import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    showAllApplications: {
        applications: {
            applicationId: string,
            company: string,
            currentStage: string,
            lastUpdatedAt: Date,
            lastUpdatedBy: string,
            name: string,
            packageCode: string,
            status: 'IN_PROGRESS' | 'APPROVED' | 'REJECTED'
        }[],
        totalCount: number,
    }
}

interface Variables {
    limit: number,
    offset: number,
}

export const GET_APPLICATIONS: TypedDocumentNode<Result, Variables> = gql`
    query GetApplications($limit: Int, $offset: Int) {
        showAllApplications(limit: $limit, offset: $offset) {
            applications {
                applicationId
                company
                currentStage
                lastUpdatedAt
                lastUpdatedBy
                name
                packageCode
                status
            }
            totalCount
        }
    }       
`
